import { Box, Card, Container, Flex } from '@radix-ui/themes'
import { createFileRoute } from '@tanstack/react-router'
import ReactMarkdown from 'react-markdown'

import { PageHeaderCard } from '@/components/layout/page-header-card'
import { CONFIGURATION } from '@/constants'

export const Route = createFileRoute('/pages/about')({
  component: () => {
    const { title, description, content } = CONFIGURATION.pages.about

    return (
      <Container size={'4'}>
        <Flex direction="column" gap="4">
          <PageHeaderCard title={title} description={description} />
          <Card size="4" className="p-0!">
            <Box p="4">
              <ReactMarkdown className="prose prose-sm prose-h2:my-0! max-w-none markdown-body">
                {content}
              </ReactMarkdown>
            </Box>
          </Card>
        </Flex>
      </Container>
    )
  },
})
